// extracted by mini-css-extract-plugin
export var active = "_ep-7";
export var blink = "_ep-8";
export var dropDownSelector = "_ep-4";
export var dropDownWrapper = "_ep-3";
export var fakeCursor = "_ep-6";
export var fontSizeButton = "_ep-9";
export var formQuillEditor = "_ep-0";
export var pressed = "_ep-a";
export var qlBlank = "_ep-1";
export var textFormattingToolbar = "_ep-2";
export var textToolbarOption = "_ep-5";